import React from 'react';
import {gettext} from '../../../../../translations';
import * as navigate from '../../../../../_web/navigation/routes';
import {withConfig} from '../../../../../config';
import {ServiceWorkerActive} from "../../../../version";
import {getUser, getUserState, isAuthenticated, isMailActivationPending, isRegistrationPending} from "../../../../session";
import {compose} from "redux";
import {connect} from "react-redux";

const Footer = ({authenticated, config}) => {
    return (
        <footer id='footer' className="footer g-bg-primary">
            <div className="container g-pt-15 g-pb-10">
                <div className="row">
                    <div className="col-md-3 g-hidden-sm-down text-center">

                        <div
                            className="d-block d-lg-flex align-items-center g-color-secondary text-uppercase g-text-underline--none--hover">


                    <span className="d-block g-hidden-sm-down g-font-weight-600 g-line-height-1_4">{config.footer_company_title}
                        <span className="d-block g-color-secondary g-font-size-10 text-center">{config.footer_company_subtitle}</span>
                  </span>
                        </div>

                    </div>

                    <div className="col-md-6 text-center">
                        <span className="d-block g-color-secondary g-font-size-13 mb-4">&#169; Autralis. All Rights Reserved</span>

                        <ul className="list-inline">
                            <li className="list-inline-item mx-3">
                                <a onClick={() => navigate.goToTerms()}
                                   className="u-link-v5 g-color-secondary g-font-weight-500 clickable">
                                    {gettext('Terms & Conditions')}
                                </a>
                            </li>
                            <li className="list-inline-item mx-3">
                                <a onClick={() => navigate.goToPrivacy()}
                                   className="u-link-v5 g-color-secondary g-font-weight-500 clickable">
                                    {gettext('Privacy')}
                                </a>
                            </li>
                            {config.faq &&
                            <li className="list-inline-item mx-3">
                                <a onClick={() => navigate.faq()}
                                   className="u-link-v5 g-color-secondary g-font-weight-500 clickable">
                                    {gettext('FAQ')}
                                </a>
                            </li>}
                            {authenticated && config.dealer_contact_information &&
                            <li className="list-inline-item mx-3">
                                <a href="https://admin.usedcars.center/sales/dealer/contact/"
                                   target="_blank"
                                   className="u-link-v5 g-color-secondary g-font-weight-500 clickable">
                                    {gettext('Contact suppliers')}
                                </a>
                            </li>}
                        </ul>

                    </div>

                    {config.ios_url !== "" && config.android_url !== "" &&
                    <div className="col-md-3 text-center g-mb-10 g-hidden-sm-down">

                        <h3 className="g-font-weight-600 g-font-size-13 text-uppercase g-color-secondary">Mobile
                            for</h3>

                        <ul className="list-inline mb-0">
                            <li className="list-inline-item g-mx-2">
                                <a href={config.ios_url}
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="u-icon-v2 g-width-35 g-height-35 g-brd-gray-light-v3 g-color-gray-dark-v5 g-bg-transparent g-font-size-13 clickable">
                                    <i className="fa fa-apple g-color-secondary"></i>
                                </a>
                            </li>
                            <li className="list-inline-item g-mx-2">
                                <a href={config.android_url}
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="u-icon-v2 g-width-35 g-height-35 g-brd-gray-light-v3 g-color-gray-dark-v5 g-bg-transparent g-font-size-13 clickable">
                                    <i className="fa fa-android g-color-secondary"></i>
                                </a>
                            </li>
                        </ul>

                    </div>}

                    {config.ios_url === "" && config.android_url === "" &&
                    <div className="col-md-3 text-center g-mb-10 g-hidden-sm-down">

                        <h3 className="g-font-weight-600 g-font-size-13 text-uppercase g-color-secondary">Responsive</h3>

                        <ul className="list-inline mb-0">
                            <li className="list-inline-item g-mx-2">
                                <img alt="responsive"
                                    src="data:image/svg+xml;utf8;base64,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"/>

                            </li>

                        </ul>
                    </div>}
                </div>
            </div>
        </footer>
    )
};


const mapStateToProps = (state) => {

    return {
        authenticated: isAuthenticated(state),
    };
};

export default compose(
    withConfig,
    connect(mapStateToProps)
)(Footer)






